//#region ../../node_modules/.pnpm/@radix-ui+primitive@1.1.7/node_modules/@radix-ui/primitive/dist/index.mjs
var e = Object.defineProperty, t = (t, n) => e(t, "name", {
	value: n,
	configurable: !0
}), n = !!(typeof window < "u" && window.document && window.document.createElement);
function r(e, n, { checkForDefaultPrevented: r = !0 } = {}) {
	return /* @__PURE__ */ t(function(t) {
		if (e?.(t), r === !1 || !t || !t.defaultPrevented) return n?.(t);
	}, "handleEvent");
}
t(r, "composeEventHandlers");
function i(e) {
	if (!n) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
t(i, "getOwnerWindow");
function a(e) {
	if (!n) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
t(a, "getOwnerDocument");
function o(e, t = !1) {
	let { activeElement: n } = a(e);
	if (!n?.nodeName) return null;
	if (s(n) && n.contentDocument) return o(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = a(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
t(o, "getActiveElement");
function s(e) {
	return e.tagName === "IFRAME";
}
t(s, "isFrame");
//#endregion
export { r as t };

//# sourceMappingURL=dist-DAt3we1k.js.map